import { foldazApi } from 'api'
import {
  FETCH_TEAMS_REQUEST,
  FETCH_TEAMS_SUCCESS,
  FETCH_TEAMS_ERROR,
  SET_TEAMS
} from './types'

export const state = {
  teams: [],
  request: {
    isLoading: false,
    error: null
  }
}

export const mutations = {
  [FETCH_TEAMS_REQUEST] (state) {
    state.request.isLoading = true
  },
  [FETCH_TEAMS_SUCCESS] (state) {
    state.request.isLoading = false
    state.request.error = null
  },
  [FETCH_TEAMS_ERROR] (state, error) {
    state.request.isLoading = false
    state.request.error = error
  },
  [SET_TEAMS] (state, value) {
    state.teams = value
  }
}

export const actions = {
  fetchTeams ({ commit, dispatch }) {
    commit(FETCH_TEAMS_REQUEST)
    return foldazApi.get('/teams')
      .then(({ data }) => commit(SET_TEAMS, data.teams))
      .then(() => commit(FETCH_TEAMS_SUCCESS))
      .catch(error => commit(FETCH_TEAMS_ERROR, error))
  }
}

export const getters = {
  teamsOptions ({ teams }) {
    return teams.map(({ id, name }) => ({ label: name, value: id }))
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/teams/teams.js